export default {
      id: "chevron-left-usage",
      viewBox: "0 0 14 23",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#chevron-left",
      toString: function () {
        return this.url;
      }
    }